import axios from "axios";

// const api = "https://h44cwslfoc.execute-api.us-east-1.amazonaws.com/dev";
const api = process.env.REACT_APP_API_ACTIVIDADES || "";

const consultarActividades = async (token) => {
  const path = `/activities`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const consultarActividadEspecifica = async (eventId, protocoloId, token) => {
  const path = `/activities?eventId=${eventId}&protocol_activity_subactivity=${protocoloId}`;

  let apiUrl = `${api}/activities?eventId=${eventId}`;

  if (protocoloId) {
    apiUrl = `${api}${path}`;
  } // Ruta del evento específico

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

// const funcionActividad = async (registro, token) => {
//   const path = `/activities/${registro.eventId}%23${registro.protocol_activity_subactivity}`; // Ruta del evento específico
//   const apiUrl = `${api}${path}`;
//   const myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json"); // Cambiado a JSON

//   let raw = JSON.stringify(registro);

//   const requestOptions = {
//     method: "PATCH",
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//     body: raw,
//     redirect: "follow",
//   };

//   try {
//     const response = await fetch(apiUrl, requestOptions);
//     const data = await response.json(); // Parsear la respuesta a JSON
//     return data; // Devolver los datos obtenidos
//   } catch (error) {
//     console.error("Error:", error);
//     throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
//   }
// };

const funcionActividad = async (registro, token) => {
  const path = `/activities/${registro.eventId}%23${registro.protocol_activity_subactivity}`;
  const apiUrl = `${api}${path}`;

  const requestOptions = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(registro),
    redirect: "follow",
  };

  try {
    const response = await fetch(apiUrl, requestOptions);
    const data = await response.json();

    if (!response.ok) {
      // Lanzar un error con el mensaje del backend si está disponible
      const errorMessage =
        data?.message || "Error inesperado al actualizar la actividad.";
      throw new Error(errorMessage);
    }

    return data;
  } catch (error) {
    console.error("Error en funcionActividad:", error);
    throw error;
  }
};

const funcionCargarS3 = async (registro, token) => {
  const path = `/activities/evidences`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.post(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al crear evento:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const consultardocumento = async (eventId = null, token) => {
  const path = "/activities/evidences"; // Ruta del evento específico
  const apiUrl = `${api}${path}`;
  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },

      params: {
        eventId: eventId,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error al consultar eventos:", error);
    throw error;
  }
};

const consultardocumentoPorProtocolo = async (
  eventId = null,
  protocolo = null,
  token
) => {
  const path = "/activities/evidences"; // Ruta del evento específico
  const apiUrl = `${api}${path}`;
  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },

      params: {
        eventId: eventId,
        protocol_activity_subactivity_id: protocolo,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error al consultar eventos:", error);
    throw error;
  }
};

// const eliminarArchivos = async (registro) => {
//   const path = `/activities/evidences`; // Ruta del evento específico
//   const apiUrl = `${api}${path}`;

//   let document = JSON.stringify(registro);

//   try {
//     const response = await axios.delete(apiUrl, document, {
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data; // Devolver los datos obtenidos
//   } catch (error) {
//     console.error('Error al crear evento:', error);
//     throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
//   }
// };

const eliminarArchivos = async (registro, token) => {
  const path = "/activities/evidences"; // Ruta del evento específico
  const apiUrl = `https://fb7j0z6zof.execute-api.us-east-1.amazonaws.com/prod${path}`;

  // const apiKey = process.env.REACT_APP_KEY_ACTIVIDADES || "";

  const data = registro;

  try {
    const response = await axios.delete(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify(data),
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al eliminar evidencia:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const editarComentario = async (registro, token, eventId, activityId) => {
  const path = "/activities"; // Ruta del evento específico
  const apiUrl = `${api}/${path}/${eventId}%23${activityId}`;
  try {
    const response = await axios.patch(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al crear evento:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const activitiesService = {
  consultarActividades,
  consultarActividadEspecifica,
  funcionActividad,
  funcionCargarS3,
  consultardocumento,
  eliminarArchivos,
  consultardocumentoPorProtocolo,
  editarComentario,
};

export default activitiesService;
